/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";
//import BissnessSubsidaries from "./BissnessSubsidaries";

const AboutUs = () => {
  const { aboutUsApi, homeApi } = apiPath;
  const [aboutUsData, aboutUsLoading] = useFetch(aboutUsApi);
  const [homeAboutData, homeAboutLoading] = useFetch(homeApi);
  const [bissData, setBissData] = useState([]);

  useEffect(() => {
    setBissData(
      homeAboutData?.filter(
        (item) => item.section_type === "business-subsidaries"
      )[0]
    );
  }, [homeAboutData]);

  if (aboutUsLoading) {
    return <Loading />;
  }

  const {
    banner_description,
    banner_subtitle,
    banner_title,
    map_img,
    value_description,
    value_img,
    value_subtitle,
    value_title,
    video,
    banner_image,
    _id,
  } = aboutUsData[0];

  const { banner_images, section_type } = bissData || [];
  // console.log("This is Banner image", banner_images);

  const imagesData = [];

  const bannerData = [
    {
      elementType: "input",
      label: "Banner Title",
      type: "Text",
      name: "banner_title",
      defaultValue: banner_title,
      required: false,
    },
    {
      elementType: "input",
      label: "Banner Subtitle",
      type: "Text",
      name: "banner_subtitle",
      defaultValue: banner_subtitle,
      required: false,
    },
    {
      elementType: "file",
      label: `Banner Image`,
      name: "banner_image",
      type: "file",
      fullCol: true,
      defaultValue: banner_image,
      required: false,
    },
  ];
  const valueData = [
    {
      elementType: "input",
      label: "value subtitle",
      type: "Text",
      name: "value_subtitle",
      defaultValue: value_subtitle,
      required: false,
    },

    {
      elementType: "input",
      label: "value title",
      type: "Text",
      name: "value_title",
      defaultValue: value_title,
      required: false,
    },
    {
      elementType: "input",
      label: "Video ID",
      type: "Text",
      name: "video",
      defaultValue: video,
      required: false,
    },
    {
      elementType: "textField",
      label: "value description",
      type: "Text",
      name: "value_description",
      defaultValue: value_description,
      required: false,
    },
    {
      elementType: "file",
      label: `Value Image`,
      name: "value_img",
      type: "file",
      fullCol: true,
      defaultValue: value_img,
      required: false,
    },

  ];
  const miscData = [
    // {
    //   elementType: "input",
    //   label: "Video ID",
    //   type: "Text",
    //   name: "video",
    //   defaultValue: video,
    //   required: false,
    // },
    {
      elementType: "file",
      label: `Map Image`,
      name: "map_img",
      type: "file",
      fullCol: true,
      defaultValue: map_img,
      required: false,
    },
  ];

  const businessSubsidiser = [
    {
      elementType: "fileBiss",
      label: "Banner Image Image",
      name: "banner_images",
      multipleData: imagesData,
      multiple: false,
      fullCol: true,
      required: false,
    },
  ];

  const update = (data) => {
    const { banner_image, map_img, value_img } = data;
    if (data.banner_image) {
      data.banner_image = {
        url: banner_image,
      };
    }
    if (data.map_img) {
      data.map_img = {
        url: map_img,
      };
    }
    if (data.value_img) {
      data.value_img = {
        url: value_img,
      };
    }
    updateData(aboutUsApi, data, _id);
    setTimeout(() => {
      window.location.reload();
    }, 800);
  };

  banner_images?.map((item, index) => {
    imagesData.push(
      {
        label: `Banner Image ${index}`,
        type: "file",
        name: "banner_images",
        defaultValue: "item 1",
      },
      {
        label: `title ${index}`,
        type: "text",
        name: "title",
        defaultValue: "item 2",
      },
      {
        label: `website ${index}`,
        type: "text",
        name: "website",
        defaultValue: "item 3",
      }
    );
  });

  return (
    <div>
      <div className="mb-8 w-full text-right font-semibold text-sm text-black hover:text-[#DB0029]">
        <Link
          to="https://banglahaatengineering.com/about"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit page
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="inline w-4 h-4 ml-1 align-text-top"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
              />
            </svg>
          </span>
        </Link>
      </div>
      <div className="bg-white p-5 shadow-md rounded-md border">
        <h1 className="md:ml-8 font-bold text-2xl">{banner_title}</h1>
        <GlobalForm data={bannerData} update={update} />
      </div>
      <div className="bg-white p-5 shadow-md rounded-md border mt-5">
        <h1 className="md:ml-8 font-bold text-2xl">{value_title}</h1>
        <GlobalForm data={valueData} update={update} />
      </div>
      <div className="bg-white p-5 shadow-md rounded-md border mt-5">
        <h1 className="md:ml-8 font-bold text-2xl">Maps</h1>
        <GlobalForm data={miscData} update={update} />
      </div>
    </div>
  );
};

export default AboutUs;
